import { API_URL } from "../config/config";
import { getRequest } from "../utils/axiosUtils";

export const fetchCouncilorList = async ({
    search = "",
}) => {
  try {
    const url = `${API_URL}/schedule/getAllCouncilor?search=${search}`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data) {
      const options = (response.data?.data || []).map((ele) => ({
        label:`${ele?.firstName || ""} ${ele?.lastName || ""}`,
        value:ele?._id
      }));

      return {data:options}
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error(error);
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }
};